import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './IconoNotificacion.css';

const IconoNotificacion = (props)=>{

    return(
        <div>
            <FontAwesomeIcon icon={props.icono} size={props.tamano}/>
            { props.numero && props.numero>0
            ?
            <div className="num-notificacion">{props.numero}</div>
            :
            null
            }
        </div>
    )

}

export default IconoNotificacion;